import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { productPurchaseType } from '../../types';

type initialStateType = {
    orders?: Array<productPurchaseType>;
    is_loading_company_orders?: boolean;
    is_adding_product_order?: boolean;
    is_deleting_product_order?: boolean;
    is_updating_product_order?: boolean;
};

const initialState: initialStateType = {
    orders: [],
    is_loading_company_orders: false,
    is_adding_product_order: false,
    is_deleting_product_order: false,
    is_updating_product_order: false,
};

const productPurchaseSlice = createSlice({
    name: 'productPurchase',
    initialState,
    reducers: {
        setAllOrders: (state, action: PayloadAction<Array<productPurchaseType>>) => {
            return {
                ...state,
                orders: action.payload
            };
        },
        onAddingOrder: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_product_order: action.payload
            };
        },
        onUpdatingOrder: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_product_order: action.payload,
            };
        },
        onDeletingOrder: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_deleting_product_order: action.payload,
            };
        },
    }
});

export const { setAllOrders, onAddingOrder, onDeletingOrder, onUpdatingOrder } = productPurchaseSlice.actions;

export default productPurchaseSlice.reducer;